import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import React from 'react';
import { store, useSelector } from 'store';
import NavItem from '../NavItem';
import { NavItemType } from 'types';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { CustomView } from 'types/userConfig/userConfig';
import { clickPreventDefaultAndStopPropagation } from 'utils/helpers';
import { useNavigate, useParams } from 'react-router';
import CreateCustomView, { CreateCustomViewRefProps } from './CreateCustomView';
import { fetchUpdateUserConfig } from 'store/slices/userConfig';
import { IconMessageCode } from '@tabler/icons-react';
import { useGetMenuMaster } from 'api/menu';
import useConfig from 'hooks/useConfig';
import { useConfirmation } from 'hooks/useConfirmation';
import ConfirmationDialog from 'ui-component/system/ConfirmationDialog';

interface AdditionalViewsProps {
  createEditView: 'create' | 'edit' | null;
  setCreateEditView: React.Dispatch<React.SetStateAction<'create' | 'edit' | null>>;
}

const AdditionalViews: React.FC<AdditionalViewsProps> = ({ createEditView, setCreateEditView }) => {
  const userConfig = useSelector((state) => state.userConfig);
  const additionalViews = useSelector((state) => state.userConfig.customViews);
  const selectedChatUser = useSelector((state) => state.chat.selectedChatUser);
  const { viewId } = useParams();
  const navigate = useNavigate();
  const { themeDirection } = useConfig();

  const { open, params, show, confirm, cancel } = useConfirmation({
    onConfirm: () => {
      deleteExistingView(itemToDeleteRef.current!);
    },
    onCancel: () => {
      itemToDeleteRef.current = null;
    },
  });

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const itemToDeleteRef = React.useRef<CustomView | null>(null);

  React.useEffect(() => {
    console.log('userCOnfig', userConfig);
  }, [userConfig]);

  const createEditFiltersRef = React.useRef<CreateCustomViewRefProps>(null);

  const editExistingFilter = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, view: CustomView) => {
      clickPreventDefaultAndStopPropagation(e);

      createEditFiltersRef.current?.setData(view.id, view.name, view.filters);
      setCreateEditView('edit');
    },
    [setCreateEditView],
  );
  const deleteExistingView = React.useCallback(
    (view: CustomView) => {
      const storeState = store.getState();

      if (viewId === view.id.toString())
        navigate(`/chats/${storeState.chat.selectedChatUser?.UserDisplayPhoneNumber || ''}`);

      const newViews = storeState.userConfig.customViews.filter((customView) => customView.id !== view.id);

      fetchUpdateUserConfig({ customViews: newViews }, true);
    },
    [navigate, viewId],
  );

  return (
    <React.Fragment>
      {additionalViews.map((view) => {
        const item: NavItemType = {
          id: view.id.toString(),
          title: view.name,
          type: 'item',
          noTranslation: true,
          url: `/chats/custom/${view.id}/${selectedChatUser?.UserDisplayPhoneNumber || ''}`,
          breadcrumbs: false,
          action: drawerOpen ? (
            <Stack direction="row" spacing={0.5} sx={{ ml: 1, mr: -0.5 }}>
              <IconButton size="small" onClick={(e) => editExistingFilter(e, view)}>
                <EditOutlinedIcon />
              </IconButton>
              {/* <IconButton size="small" onClick={(e) => deleteExistingView(e, view)}> */}
              <IconButton
                size="small"
                onClick={(e) => {
                  clickPreventDefaultAndStopPropagation(e);
                  itemToDeleteRef.current = view;
                  show('מחיקת תצוגה', `האם אתה בטוח שברצונך למחוק את התצוגה "${view.name}"?`);
                }}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Stack>
          ) : undefined,
          actionHoverOnly: true,
          icon: IconMessageCode,
        };
        return (
          <Tooltip
            title={item.title}
            key={view.id}
            placement={themeDirection === 'rtl' ? 'left' : 'right'}
            arrow
          >
            <Box width="100%">
              <NavItem item={item} level={1} />
            </Box>
          </Tooltip>
        );
      })}

      <CreateCustomView
        open={Boolean(createEditView)}
        onClose={() => setCreateEditView(null)}
        createOrEdit={createEditView}
        ref={createEditFiltersRef}
      />

      <ConfirmationDialog
        open={open}
        title={params?.title || ''}
        message={params?.message || ''}
        onConfirm={confirm}
        onCancel={cancel}
        onClose={cancel}
      />
    </React.Fragment>
  );
};

export default AdditionalViews;
